import { Link } from "react-router-dom";

const FOOTER_CITIES = [
  { name: "București", slug: "bucuresti" },
  { name: "Cluj-Napoca", slug: "cluj-napoca" },
  { name: "Timișoara", slug: "timisoara" },
  { name: "Iași", slug: "iasi" },
  { name: "Brașov", slug: "brasov" },
  { name: "Constanța", slug: "constanta" },
  { name: "Craiova", slug: "craiova" },
  { name: "Oradea", slug: "oradea" },
];

const FOOTER_OCCASIONS = [
  { title: "Ziua de naștere", slug: "ziua-de-nastere" },
  { title: "Aniversare cuplu", slug: "aniversare" },
  { title: "Valentine's Day", slug: "valentine" },
  { title: "8 Martie", slug: "8-martie" },
  { title: "Crăciun", slug: "craciun" },
  { title: "Botez", slug: "botez" },
];

const AppFooter = () => (
  <footer className="bg-foreground text-background mt-auto">
    <div className="max-w-6xl mx-auto px-4 py-14">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-10">

        {/* Coloana 1 — Brand */}
        <div className="col-span-2 md:col-span-1 space-y-4">
          <Link to="/" className="flex items-baseline gap-1">
            <span className="font-playfair font-bold italic text-lg text-primary">Surprize</span>
            <span className="font-inter text-sm text-background/60"> la Domiciliu</span>
          </Link>
          <p className="text-sm text-background/60 leading-relaxed font-inter">
            Prima platformă națională de livrare a surprizelor personalizate în România. Parteneri verificați în toate județele.
          </p>
          <Link to="/comanda-surpriza" className="inline-flex items-center gap-1 text-sm font-medium text-primary hover:text-primary/80 transition-colors font-inter">
            Trimite o surpriză →
          </Link>
          <div className="pt-2 text-sm font-inter text-background/50">
            Construită pentru românii de pretutindeni 🇷🇴
          </div>
        </div>

        {/* Coloana 2 — Orașe */}
        <div className="space-y-3">
          <h3 className="text-sm font-semibold text-background/90 font-playfair">Surprize în orașe</h3>
          <ul className="space-y-2">
            {FOOTER_CITIES.map((city) => (
              <li key={city.slug}>
                <Link
                  to={`/surprize-la-domiciliu/${city.slug}`}
                  className="text-sm text-background/55 hover:text-primary transition-colors font-inter"
                  title={`Surprize la domiciliu ${city.name}`}
                >
                  {city.name}
                </Link>
              </li>
            ))}
            <li>
              <Link to="/orase" className="text-sm text-primary hover:text-primary/80 font-medium font-inter transition-colors">
                → Toate orașele
              </Link>
            </li>
          </ul>
        </div>

        {/* Coloana 3 — Ocazii */}
        <div className="space-y-3">
          <h3 className="text-sm font-semibold text-background/90 font-playfair">Ocazii populare</h3>
          <ul className="space-y-2">
            {FOOTER_OCCASIONS.map((occ) => (
              <li key={occ.slug}>
                <Link
                  to={`/ocazii/${occ.slug}`}
                  className="text-sm text-background/55 hover:text-primary transition-colors font-inter"
                >
                  {occ.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Coloana 4 — Companie */}
        <div className="space-y-3">
          <h3 className="text-sm font-semibold text-background/90 font-playfair">Companie</h3>
          <ul className="space-y-2">
            {[
              { label: "Despre noi", to: "/despre-noi" },
              { label: "Cum funcționează", to: "/cum-functioneaza" },
              { label: "Pachete & prețuri", to: "/pachete" },
              { label: "Devino partener", to: "/devino-partener" },
              { label: "Contact", to: "/contact" },
            ].map((link) => (
              <li key={link.to}>
                <Link
                  to={link.to}
                  className="text-sm text-background/55 hover:text-primary transition-colors font-inter"
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="border-t border-background/10 mt-12 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background/40 font-inter">
        <span>© {new Date().getFullYear()} Surprize la Domiciliu. Toate drepturile rezervate.</span>
        <span className="flex items-center gap-2">
          <span className="w-1.5 h-1.5 rounded-full bg-primary inline-block" />
          4.9 ★ din 127 recenzii
        </span>
      </div>
    </div>
  </footer>
);

export default AppFooter;
